import {InjectionToken} from '@angular/core';
import i18next, {i18n} from 'i18next';

export const I18NEXT_INSTANCE = new InjectionToken<i18n>('I18NEXT_INSTANCE', {
  providedIn: 'root',
  factory: () => i18next.createInstance(),
});
